// src/eh/org.js
// ─────────────────────────────────────────────────────────────────────────────
// Verified organisation facts. Every field below was taken from ICENECDEV's own
// website (icenecdev.org/about.php, retrieved 2026-08-19). Do NOT add claims
// here that are not sourced from the organisation — the platform is used to
// approach donors, and an invented accreditation would be a serious problem.
// ─────────────────────────────────────────────────────────────────────────────

export const ORG = {
  acronym: "ICENECDEV",
  name: "International Center for Environmental Education & Community Development",
  founded: 2005,
  registration: "Reg. 43/G.37/D.14/1/VOL.BAPP — Cameroon Law No. 90/53 of December 1990",
  headquarters: "P.O. Box 641, Lower Bokova, Mile 15, Buea, South West Region, Cameroon",
  mission: "Empowering people to protect the environment",
  vision:
    "Transforming people to change attitudes in order to appreciate and value our ecological assets and natural resources for our collective future",
  coreValue: "Connecting people to nature",
  website: "https://www.icenecdev.org",
  source: "https://www.icenecdev.org/about.php",
  retrieved: "2026-08-19",
  // Thematic areas as the organisation lists them. CoastClear sits inside
  // environmental education, sustainable waste management, water management,
  // and climate change / disaster risk reduction.
  focusAreas: [
    "Environmental education and governance",
    "Climate change and biodiversity conservation",
    "Air quality monitoring",
    "Sustainable waste management",
    "Sustainable forest management",
    "Conservation agriculture",
    "Renewable energy",
    "Water management",
    "Food security and disaster risk reduction",
  ],
  accreditations: [
    "UN Department of Public Information (associated)",
    "UN Convention to Combat Desertification (UNCCD)",
    "UN Global Compact (participant)",
    "UN Environment Programme (UNEP)",
    "UNFCCC",
    "ECOSOC — Special Consultative Status",
    "UNCTAD (2012)",
  ],
};

export const CREDIT = "Developed by Chifen Sama, deployed under ICENECDEV.";

// ─────────────────────────────────────────────────────────────────────────────
// The two organisations the platform is presented under, in the order they are
// shown. They are rendered as equals — same tile, same optical weight — so this
// list is the single place that order is decided.
//
// ICENECDEV's fields come from ORG above, every one of them sourced.
//
// For Ecotour Enterprise the ONLY thing on record is the name as it is set in
// the logo file the owner supplied. No website, no founding date, no
// description and no accreditation, because none of that has been verified —
// and this platform is shown to funders, where an invented partner detail
// would be exactly as damaging as an invented statistic. Add fields here only
// with a source, the way ORG does.
// ─────────────────────────────────────────────────────────────────────────────
export const PARTNERS = [
  {
    id: "icenecdev",
    short: ORG.acronym,
    name: ORG.name,
    href: ORG.website,
  },
  {
    id: "ecotour",
    short: "Ecotour Enterprise",
    name: "Ecotour Enterprise",
    href: null,
  },
];
